export default __webpack_public_path__ + "static/media/ic-crops-green-manure.e90d5c04.svg";